
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CookieConsent',
  emits: ['cookie-status-change'],
  data() {
    return {
      isCookieActive: true,
    };
  },
  methods: {
    acceptCookies() {
      this.isCookieActive = false;
      this.$emit('cookie-status-change', false);
    },
  },
});
